// extracted by mini-css-extract-plugin
export default {"button_blue":"styles_button_blue__XBDrM","button_grey":"styles_button_grey__B4tX-","button_green":"styles_button_green__whAqf"};